module.exports = __webpack_public_path__ + "static/media/footer-icon-medium.9b7edbd1.svg";